enum ERole {
  InventoryAdmin = "InventoryAdmin",
  InventorySenior = "InventorySenior",
  InventoryService = "InventoryService",
  InventoryStandard = "InventoryStandard",
}

export default ERole;
